import { Colors } from "../consts/Colors";

export default class Entity extends Phaser.GameObjects.Container {
    constructor(scene, x, y, params = { showHitbox: true, texture: null, level: null }) {
        super(scene, x, y, []);

        this.scene = scene;
        scene.add.existing(this);
        this.addBody(params)
    }

    addBody(params) {
        this.texture = this.scene.add.rectangle(0, 0, 180*0.36, 180*0.36, Colors.Elmt.Violet).setOrigin(1)


        this.add(this.texture)

        this.addHitbox()
        this.displayHitbox(params.showHitbox)
    }

    addHitbox() {
        this.hitbox = this.scene.add.rectangle(0, 0, 160*0.36, 160*0.36, Colors.Elmt.DarkYellow).setOrigin(1)
        this.add(this.hitbox)
    }

    displayHitbox(isVisible) {
        this.hitbox.setAlpha(isVisible ? 1 : 0)
    }
}